// import axios from "axios";

// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// // 🔥 Create instance
// const apiService = axios.create({
//   baseURL: API_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
// });

// // ==========================
// // ✅ REQUEST INTERCEPTOR
// // ==========================
// apiService.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("accessToken");

//     // Always attach token unless explicitly skipped
//     if (!config.skipAuth && token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // ==========================
// // ✅ RESPONSE INTERCEPTOR
// // ==========================
// apiService.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // 🔥 Handle 401 and token refresh
//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       !originalRequest.skipAuth
//     ) {
//       originalRequest._retry = true;

//       try {
//         // const refreshToken = localStorage.getItem("refreshToken");

//         const refreshToken = localStorage.getItem("refreshToken");

//         if (!refreshToken || refreshToken.split(".").length !== 3) {
//           console.error("Invalid refresh token detected:", refreshToken);

//           localStorage.clear();
//           window.location.href = "/";
//           return Promise.reject("Invalid refresh token");
//         }

//         // const response = await axios.post(
//         //   `${API_URL}/api/refresh-token/`,
//         //   { refresh_token: refreshToken },
//         //   {
//         //     headers: {
//         //       "Content-Type": "application/json",
//         //       Accept: "application/json",
//         //     },
//         //   }
//         // );

//         const response = await axios.post(
//           `${API_URL}/api/refresh-token/`,
//           { refresh_token: refreshToken.replace("Bearer ", "") },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//             },
//           }
//         );

//         const newAccessToken = response.data.access_token || response.data.access;

//         localStorage.setItem("accessToken", newAccessToken);

//         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

//         return apiService(originalRequest);
//       } catch (refreshError) {
//         console.error("Refresh token failed:", refreshError);

//         // Logout user
//         localStorage.clear();
//         window.location.href = "/";

//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default apiService;



















import axios from "axios";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// ==========================
// AXIOS INSTANCE
// ==========================
const apiService = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// ==========================
// REFRESH CONTROL FLAGS
// ==========================
let isRefreshing = false;
let refreshSubscribers = [];

// ==========================
// HELPER: Notify queued requests
// ==========================
const onRefreshed = (token) => {
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
};

const addSubscriber = (cb) => {
  refreshSubscribers.push(cb);
};

// ==========================
// REQUEST INTERCEPTOR
// ==========================
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token && token !== "undefined" && token !== "null") {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ==========================
// RESPONSE INTERCEPTOR
// ==========================
apiService.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Only handle 401
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.skipAuth
    ) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshToken");

      // Validate refresh token
      if (
        !refreshToken ||
        refreshToken === "undefined" ||
        refreshToken.split(".").length !== 3
      ) {
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject("Invalid refresh token");
      }

      // ==========================
      // If refresh already running → queue request
      // ==========================
      if (isRefreshing) {
        return new Promise((resolve) => {
          addSubscriber((newToken) => {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            resolve(apiService(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const res = await axios.post(
          `${API_URL}/api/refresh-token/`,
          { refresh_token: refreshToken.replace("Bearer ", "") },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        const newAccessToken = res.data.token;
        const newRefreshToken = res.data.refreshToken;

        // 🔴 Validate response
        if (!newAccessToken || newAccessToken === "undefined") {
          throw new Error("Invalid access token from refresh API");
        }

        // Save tokens
        localStorage.setItem("accessToken", newAccessToken);

        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }

        // Update all queued requests
        onRefreshed(newAccessToken);

        // Retry original request
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        return apiService(originalRequest);
      } catch (refreshError) {
        console.error("Refresh failed:", refreshError);

        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default apiService;